import "./style.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./app/store";
import App from "./App.jsx";
import { ThemeProvider } from "./components/layouts/themeProvider";
import { Toaster } from "./components/ui/sonner";

const root = ReactDOM.createRoot(document.querySelector("#root"));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
        <Toaster richColors position="top-right" />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);
